module.exports = __webpack_public_path__ + "static/Melio Payments-64d0f8aa788c57f52b171d0be7f58493.jpg";